/**
 * One vote request per review at a time, across every copy of a review card on the page.
 *
 * A product's top positive or critical review is picked by helpfulness while the recent list is
 * ordered by date, so the same review is often rendered twice. Two votes in flight can reach the
 * database in either order and answer in a third, and each answer carries the count the page then
 * displays — so the only way the last message shown is the true one is for there never to be two.
 *
 * This lives in a module rather than in the component because `<script setup>` runs per instance:
 * a queue declared there would be one queue per card, which is the thing it exists to prevent.
 */
const votesInFlight = new Map<number, Promise<void>>();

export function queueReviewVote(
    reviewId: number,
    send: () => Promise<void>,
): void {
    const queued = (votesInFlight.get(reviewId) ?? Promise.resolve()).then(
        send,
    );

    votesInFlight.set(reviewId, queued);
}
